export enum PlatformLicenseEnum {
  JuvoPos = "JuvoPos",
  JuvoKiosk = "JuvoKiosk",
  JuvoTrack = "JuvoTrack",
  JuvoDeliverect = "JuvoDeliverect",
  JuvOffice = "JuvOffice",
  JuvoOlo = "JuvOnline",
  JuvoKDS = "JuvoKDS",
  JuvoPay = "JuvoPay",
  JuvoMobile = "JuvoMobile",
}